import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { Capacitor, PluginListenerHandle } from '@capacitor/core';
import { PushNotifications, ActionPerformed } from '@capacitor/push-notifications';

if (environment.production) {
  enableProdMode();
}

(window as any).pendingNotificationActions = [];

if (Capacitor.isPluginAvailable('PushNotifications')) {
  try {
    const handle = PushNotifications.addListener('pushNotificationActionPerformed', (action: ActionPerformed) => {
      console.log('PushNotifications Global Listener - action captured:', JSON.stringify(action));
      (window as any).pendingNotificationActions.push(action);
    });
    (window as any).globalPushListener = handle;
  } catch (e) {
    console.error('Error adding global push notification action listener:', e);
  }
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
